import { render, staticRenderFns } from "./EditStar.vue?vue&type=template&id=c9984600&scoped=true&"
import script from "./EditStar.vue?vue&type=script&lang=js&"
export * from "./EditStar.vue?vue&type=script&lang=js&"
import style0 from "./EditStar.vue?vue&type=style&index=0&id=c9984600&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9984600",
  null
  
)

export default component.exports